
const { customValid } = require('../../utils/validator')

import { mapState, mapActions, mapMutations } from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import questionIcon from 'assets/icons/icon-customer-service@3x.png'
import iconKefu from 'assets/icons/icon_kefu1@3x.png'
import isValid from '../../utils/validor'
import editIcon from 'assets/icons/icon_pen_edit@3x.png'
import { formatDate } from '../../utils/date'
import meiqia from '../../utils/meiqia'

export default {
name: 'SportsTourCustomConfirm',
components: {
XHeader,
XNumber,
XInput,
Datetime,
Group,
Checker,
CheckerItem,
XButton,
XTextarea,
},
data() {
return {
questionIcon,
iconKefu,
editIcon,
initCustomOrderData: {
customId: 0,
sportsTourRouteId: 0,
personCount: 2,
services: [],
contactInfo: {
id: '',
name: null,
mobile: null,
},
departureStart: null,
departureEnd: null,
remark: null,
},

minCount: 1,
}
},
computed: {
...mapState({
sportsTourRoute: ({ sportsTour }) => sportsTour.sportsTourRoute,
services: ({ custom }) => custom.services,
attn: ({ attn }) => attn.commonAttn,
customOrderData: ({ order }) => order.customOrderData,
}),
departureStartText() {
return this.customOrderData.departureStart ? this.customOrderData.departureStart : '出发时间'
},
departureEndText() {
return this.customOrderData.departureEnd ? this.customOrderData.departureEnd : '返程时间'
},
dateStartValid() {
return !!this.customOrderData.departureStart
},
dateEndValid() {
return !!this.customOrderData.departureEnd
},
categoryName() {
if (this.sportsTourRoute.category && this.sportsTourRoute.category.name) {
return `${this.sportsTourRoute.category.name}定制`
}
return '观赛日定制'
},
hasAttn() {
if (this.customOrderData.contactInfo.id) {
return true
}
if (this.attn.id) {
this.customOrderData.contactInfo = this.attn
return true
}
return false
},
},
mounted() {
document.body.scrollTop = 0
},
methods: {
...mapMutations({
saveCustomOrderData: 'SAVE_CUSTOM_ORDER_DATA',
}),
...mapActions(['fetchUserCommonAttnByUserId', 'fetchCustomOrderServices', 'fetchSportsTourRouteById', 'fetchBasicConfig', 'showToast']),
routeTo(route) {
this.$router.push(route)
},
showDatePopup(type) {
const self = this
const today = formatDate(new Date(), 'yyyy-MM-dd')
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: today,
onConfirm(val) {







if (!self.isValidTime(val)) {
return
}
if (type === 'start') {
self.customOrderData.departureStart = val
} else {
self.customOrderData.departureEnd = val
}
},
})
},
mutateOrder() {
const { routeId } = this.$route.params
const self = this
self.customOrderData.sportsTourRouteId = routeId
self.saveCustomOrderData(self.customOrderData)
},
goToAttn(type, attnId) {
const query = { from: 'customOrder' }
if (attnId) {
query.id = attnId
} else {
query.type = 'attn'
}
this.mutateOrder()
this.$router.push({
name: `attn-${type}`,
query,
})
},
isValidTime(dateStr) {
if (new Date(dateStr) < Date.now()) {
this.showToast({
content: '请选择当前日期以后的日期！',
size: '18em',
})
return false
}
return true
},
placeCustomOrder() {
const self = this

const { routeId } = this.$route.params
const { userId } = this.$jwt
const { contactInfo: { name, mobile }, departureStart, departureEnd, personCount,
services, remark } = this.customOrderData

const mobileValid = customValid.apply(self, [mobile, null, '请输入联系人手机号'])
const contactNameValid = customValid.apply(self, [name, null, '请输入联系人姓名'])
const departureStartValid = customValid.apply(self, [departureStart, null, '请选择出发日期'])
const departureEndValid = customValid.apply(self, [departureEnd, null, '请选择返程日期'])

if (!departureStartValid || !departureEndValid || !contactNameValid || !mobileValid) {
return
}

if (!this.isValidTime(departureStart)) {
return
}

if (!this.isValidTime(departureEnd)) {
return
}

if (!isValid('mobile', mobile)) {
self.showToast({
content: '手机号码填写有误，请输入11位国内手机号码！',
size: '21em',
time: 3000,
})
return
}

const req = {
userId,
city: {},
departureStart: new Date(departureStart).getTime(),
departureEnd: new Date(departureEnd).getTime(),
sportsTourRouteId: +routeId,
personCount: +personCount,
services,
contactInfo: {
name,
mobile,
},
remark,
}

this.$http.post('/api/custom/placeOrder', req).then(res => res.json())
.then(() => {

self.$router.push({ name: 'custom-success' })
})
.catch((err) => {
self.showToast({
content: err.body.resultInfo,
})
})
},
chat() {
window._MEIQIA('showPanel') 
},
xiangqing() {
window.location.href = `/h5/sportsTourRouteIntroduction_detail/${this.sportsTourRoute.id}`
},
},
created() {
document.title = '提交定制需求'
meiqia.init(null, meiqia.travelGroupToken)
const { routeId } = this.$route.params

this.fetchUserCommonAttnByUserId(this.$jwt.userId)
this.fetchCustomOrderServices()
this.fetchSportsTourRouteById({
routeId,
}).then(() => {
if (+routeId !== +this.customOrderData.sportsTourRouteId) {
this.saveCustomOrderData(this.initCustomOrderData)

}
})
},
}



// WEBPACK FOOTER //
// ./client/components/SportsTour/SportsTourCustomConfirm.vue